import type {
  TClientData,
  TClientServerResponse
} from '@/AdminPanel/pages/Clients/types/client.types';

export const clientMapperAdmin = (data: TClientServerResponse): TClientData => {
  return {
    uuid: data.uuid || '',
    personal_id: data.personal_id || '',
    first_name: data.first_name || '',
    middle_name: data.middle_name || '',
    last_name: data.last_name || '',
    phone_number: data.phone_number || '',
    birth_date:
      data.birth_date instanceof Date
        ? data.birth_date.toISOString()
        : data.birth_date || '',
    salary: data.salary || 0,
    additional_income: data.additional_income || 0,
    marital_status_uuid: data.marital_status_uuid || '',
    job_title: data.job_title || '',
    child_count: data.child_count || 0,
    social_status_uuid: data.social_status_uuid || '',
    organization_type_uuid: data.organization_type_uuid || '',
    company_activity_type_uuid: data.company_activity_type_uuid || null,
    title_company: data.title_company || '',
    Client_Add_Contacts: data.Client_Add_Contacts || null,
    work_tel_number: data.work_tel_number || '',
    work_address: data.work_address || '',
    gender_uuid: data.gender_uuid || ''
  };
};
